export enum EnumTipoCalculo {
    Fixo = 0,
    Modulo = 1,
    Bilhetagem = 2
}